//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        props: {
            asset: Object
        },
        components: {

        },
        mounted(){
            var width = $(this.$refs.curr).width();
            var height = $(this.$refs.curr).height();

            if(width===height){
                $(this.$refs.videoTag).attr('style','width: 60%;height: 60%;position: absolute;top: 20%; left: 20%;')
            } else if (height > width) {
                var heightTag = parseInt(60*width/height);
                var topPos = parseInt((100-heightTag)/2);
                $(this.$refs.videoTag).attr('style','width: 60%;height: '+heightTag+'%;position: absolute;top: '+topPos+'%; left: 20%;')
            } else if(height < width) {
                var widthTag = parseInt(60*height/width);
                var leftPos = parseInt((100-widthTag)/2);
                $(this.$refs.videoTag).attr('style','width: '+ widthTag +'%;height:60%;position: absolute;top: 20%; left: '+leftPos+'%;')
            }
        },
        methods: {

        },
        data () {
            return {
                defaultImg: 'this.src="' + require('../../assets/img/no_pic.png') + '"',
                videoTag:require('../../assets/img/video.png')
            }
        },
        watch: {

        }
    }



// WEBPACK FOOTER //
// ./src/components/league/momentThumb.vue